export default {
      id: "i-alpha-invest-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/sprite.svg#i-alpha-invest",
      toString: function () {
        return this.url;
      }
    }